import { IconNames } from './icon-names';

export enum SCode {
  S00 = 'S00',
  S01 = 'S01',
  S02 = 'S02',
  S03 = 'S03',
  S04 = 'S04',
  S05 = 'S05',
  S07 = 'S07',
  S09 = 'S09',
  S10 = 'S10',
  S11 = 'S11',
  S12 = 'S12',
  S13 = 'S13',
  S15 = 'S15',
  S16 = 'S16',
  S17 = 'S17',
  S18 = 'S18',
  S23 = 'S23',
  S24 = 'S24',
  S25 = 'S25',
  S26 = 'S26',
  S27 = 'S27',
  S30 = 'S30',
  S31 = 'S31',
  S32 = 'S32',
  S33 = 'S33',
  S34 = 'S34',
  S40 = 'S40',
  S45 = 'S45',
  S46 = 'S46',
  S50 = 'S50',
  S51 = 'S51',
  S52 = 'S52',
  S53 = 'S53',
}

export const S_CODE_ICONS = new Map<SCode, IconNames>([
  [SCode.S00, IconNames.BoxDelivery],
  [SCode.S01, IconNames.ComponentsReservation],
  [SCode.S02, IconNames.BoxDelivery],
  [SCode.S03, IconNames.BoxDeliveryConnected],
  [SCode.S05, IconNames.Delivery],
  [SCode.S04, IconNames.PlaneStart],
  [SCode.S07, IconNames.PlaneLand],
  [SCode.S09, IconNames.Message],
  [SCode.S10, IconNames.ComponentsReservation],
  [SCode.S11, IconNames.ComponentsReservation],
  [SCode.S12, IconNames.ComponentsReservation],
  [SCode.S13, IconNames.ComponentsReservation],
  [SCode.S15, IconNames.Locator],
  [SCode.S16, IconNames.ComponentsReservation],
  [SCode.S17, IconNames.ComponentsReservation],
  [SCode.S18, IconNames.ComponentsReservation],
  [SCode.S23, IconNames.Clipboard],
  [SCode.S24, IconNames.HandoverCheck],
  [SCode.S25, IconNames.ComponentsReservation],
  [SCode.S26, IconNames.Clipboard],
  [SCode.S27, IconNames.ClipboardCheckmark],
  [SCode.S30, IconNames.ClipboardCheckmark],
  [SCode.S31, IconNames.DeliveryCheckmark],
  [SCode.S32, IconNames.EmergencyExit],
  [SCode.S33, IconNames.Exit],
  [SCode.S34, IconNames.ComponentsReservation],
  [SCode.S40, IconNames.ComponentsReservation],
  [SCode.S45, IconNames.ComponentsReservation],
  [SCode.S46, IconNames.ComponentsReservation],
  [SCode.S50, IconNames.ComponentsReservation],
  [SCode.S51, IconNames.ComponentsReservation],
  [SCode.S52, IconNames.ComponentsReservation],
  [SCode.S53, IconNames.ComponentsReservation],
]);
